import { Injectable } from '@angular/core';
import { InternalDatabaseService } from '../internal/internal-database.service';
import { BehaviorSubject, from } from 'rxjs';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { ChecklistQuestion } from '@stockcare-models/ChecklistQuestion';
import { ChecklistQuestionStorage } from './checklist-question-storage';

@Injectable({
  providedIn: 'root',
})
export class ChecklistQuestionStorageService {
  readonly table: string;
  readonly Index: string;
  readonly IdIndex: string;
  enableLocaldb: boolean;
  checklistQuestions: ChecklistQuestion[] = [];

  private questionsUpdated = new BehaviorSubject<ChecklistQuestion[]>([]);
  public questionsUpdated$ = this.questionsUpdated.asObservable();

  constructor(
    private internalDatabaseService: InternalDatabaseService,
    private readonly settingsService: SettingsService
  ) {
    const table = ChecklistQuestionStorage.getTableDefinition();
    this.table = table.TableName;
    this.Index = table.Indexes[0].Name;
    this.IdIndex = table.Indexes[1].Name;
  }

  getSettings() {
    this.enableLocaldb = this.settingsService.getBooleanSetting(Settings.ENABLE_INDEXED_DB);
  }

  async getAllChecklistQuestions(): Promise<ChecklistQuestion[]> {
    this.getSettings();

    if (!this.enableLocaldb) {
      return this.checklistQuestions;
    }

    try {
      const questions = await this.internalDatabaseService.getAll<ChecklistQuestion>(this.table);

      return questions || [];
    } catch (error) {
      console.error('[ChecklistQuestionStorageService] Error getting checklist questions from IndexedDB:', error);
      return [];
    }
  }

  async syncQuestionsFromApi(questions: ChecklistQuestion[]): Promise<void> {
    this.getSettings();

    if (!questions || questions.length === 0) {
      return;
    }

    try {
      if (!this.enableLocaldb) {
        this.checklistQuestions = [...questions];
      } else {
        await this.internalDatabaseService.deleteAll(this.table);
        await this.internalDatabaseService.addRange(this.table, questions);
      }

      this.questionsUpdated.next(questions);

    } catch (error) {
      console.error('[ChecklistQuestionStorageService] Error syncing checklist questions:', error);
      throw error;
    }
  }
}
